export enum AnnouncementPriority {
  CRITICAL = 'CRITICAL',
  MEDIUM = 'MEDIUM',
  LOW = 'LOW',
}
